import { Flex } from "@chakra-ui/react";
import { useNewHireJourneyDetailQuery } from "features/NewHireJourney/hooks";
import { CollapsibleHistory } from "features/PlatformEvents";
import EmailForm from "features/Resources/Email/Layout/EmailForm";
import SentEmail from "features/Resources/Email/Layout/SentEmail";
import { Email } from "features/Resources/Email/models";

interface EmailDrawerFormProps {
  email: Email;
}

export default function EmailDrawerForm({ email }: EmailDrawerFormProps) {
  const { data: newHireJourney } = useNewHireJourneyDetailQuery(email?.newHireJourneyId);
  if (!email) {
    return null;
  }

  return (
    <Flex direction="column">
      {email && (
        ["delivered", "skipped"].includes(email.status) ? (
          <SentEmail email={email} includeHeader={false} includeStatus={false} includeJourney={false} />
        ) : (
          <EmailForm
            data={email}
            includeHeader={false}
            includeMenu={false}
            isPending={newHireJourney?.isPending || false}
            includeStatus={false}
            includeJourney={false}
          />
        )
      )}
      <CollapsibleHistory entityId={email.id} entityType="Email" eventType="email" />
    </Flex>
  );
}
